// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__3XWdp","footer":"ModalError_footer__13tG4"};